
export function formatDate(dateStr) {
  function convertDateForIos(dateStr) {
    if (!dateStr) {
      return null;
    }
    
    const arr = dateStr.split(/[- :]/);
    
    if (arr.length < 3) {
      return null;
    }
    
    return new Date(arr[0], arr[1] - 1, arr[2], arr[3] || 0, arr[4] || 0, arr[5] || 0);
  }

  const date = convertDateForIos(dateStr);

  if (!date || isNaN(date.getTime())) {
    return {
      formattedDate: 'Invalid Date',
      day: '00',
      month: '00'
    };
  }

  const day = String(date.getDate()).padStart(2, '0');      
  const month = String(date.getMonth() + 1).padStart(2, '0'); 
  const year = date.getFullYear();                         

  let hours = date.getHours();                             
  const minutes = String(date.getMinutes()).padStart(2, '0');                                 

  const formattedDate = `${day}.${month}.${year} / ${String(hours).padStart(2, '0')}.${minutes} Uhr`;

  return {
    formattedDate,
    day,
    month
  };
}